export default __webpack_public_path__ + "assets/images/email-icon-372dc04e.svg";